// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueI18n from 'vue-i18n'
import zh from './i18n/zh'
import en from './i18n/en'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import './assets/theme/index.css'
import Common from './Common'
import * as echarts from 'echarts'
import Vue2Editor from 'vue2-editor'

Vue.config.productionTip = false
Vue.use(Vue2Editor)
Vue.use(VueAxios, axios)
Vue.use(VueI18n)
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(Vuex)
Vue.prototype.Common = Common
Vue.prototype.$echarts = echarts
//Vue.axios.defaults.baseURL = 'http://localhost:19005'
Vue.axios.defaults.baseURL = 'http://dd.ddyuewu.com'
Vue.axios.defaults.headers.post['Content-Type'] = 'application/json'
Vue.axios.defaults.transformRequest = function (data, headers) {
  var session = window.localStorage.getItem('sessionid')
  if (session) {
    if (!data) {
      data = {}
    }
    data.sessionid = session
  }
  return JSON.stringify(data)
}


axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  let reg = /^\/api\//;
  if (!reg.test(config.url)) {
      config.url = '/dada' + config.url
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

Vue.axios.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    if (response.data.errcode == -2) {
      // response.data.errmsg = '登录超时，请重新登录'
      window.localStorage.clear()
      router.push({ name: 'Login' })
      return Promise.reject('')
    }
    return response
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error)
  }
)

const store = new Vuex.Store({
  state: {
    equipmentWhere: null,
    deviceWhere: null,
    device: {},
    deviceinnerid: '',
    permission: {},
    weather: {},
    project: {},
    devicelist: [],
    compList: [],
    slavenum: 99,
    debugger:false
  },
  mutations: {
    clearAll(state) {
      console.log('clearAll')
      state.device = {}
      state.equipmentWhere = null
      state.deviceWhere = null
      state.deviceinnerid = ''
      state.permission = {}
      state.weather = {}
      state.project = {}
      state.devicelist = []
      state.slavenum = 99
      state.compList = []
      state.debugger=false
    },
    updateCompList(state, c) {
      state.compList = []
      c.forEach((i) => {
        state.compList.push(i)
      })
    },
    updatePermission(state, p) {
      for (let key in p) {
        state.permission[key] = p[key]
      }
    },
    updateWeather(state, w) {
      for (let key in w) {
        state.weather[key] = w[key]
      }
    },
    updateProject(state, p) {
      state.project = {}
      for (let key in p) {
        state.project[key] = p[key]
      }
    },
    updateDeviceList(state, t) {
      state.devicelist = []
      t.forEach((i) => {
        state.devicelist.push(i)
      })
    }
  }
})

// 路由拦截没有登录session信息，则跳转到登录界面
router.beforeEach((to, from, next) => {
  if (to.name == 'Login') {
    next()
  } else {
    var session = window.localStorage.getItem('sessionid')
    var user = window.localStorage.getItem('customer')
    if (!session || !user) {
      next({ name: 'Login' })
    } else {
      next()
    }
  }
})

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'zh',
  messages: {
    zh:{...zh,...zhLocale},
    en:{...en,...enLocale}
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store: store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js